export default "__VITE_ASSET__yq$4V5S5__"